import { ApplicationCRMMetadataSchema, ApplicationSettingsSchema } from "@superwall-me/schema";
import db, { ApplicationPlatform } from "./db";
export const getSettings = async (applicationId)=>{
    const application = await db.applicationSettings.findUnique({
        where: {
            applicationId
        },
        select: {
            settings: true
        }
    }) || {
        settings: {}
    };
    return parseApplicationSettings(application).settings;
};
export const ApplicationPlatformStringMap = {
    [ApplicationPlatform.STRIPE]: "Web 2 App",
    [ApplicationPlatform.ANDROID]: "Android",
    [ApplicationPlatform.IOS]: "iOS",
    [ApplicationPlatform.WEB]: "Stripe",
    [ApplicationPlatform.PADDLE]: "Paddle"
};
export const setSettings = async (applicationId, settings)=>{
    const applicationSettings = await db.applicationSettings.findUnique({
        where: {
            applicationId
        }
    });
    let existingSettings = (applicationSettings || {
        settings: {}
    }).settings;
    Object.entries(settings).forEach(([key, value])=>{
        if (value === null) {
            delete existingSettings[key];
        } else {
            existingSettings[key] = value;
        }
    });
    if (applicationSettings) {
        await db.applicationSettings.update({
            where: {
                applicationId
            },
            data: {
                settings: existingSettings
            }
        });
    } else {
        await db.applicationSettings.create({
            data: {
                applicationId,
                settings: existingSettings
            }
        });
    }
};
export const parseApplication = (application)=>{
    const featuresEnabled = application.featuresEnabled ? application.featuresEnabled.split(",").map((f)=>f.trim()) : [];
    const crmMetadata = application.crmMetadata ? ApplicationCRMMetadataSchema.parse(application.crmMetadata) : {};
    return {
        ...application,
        crmMetadata,
        featuresEnabled
    };
};
export const parseApplicationSettings = (applicationSettings)=>{
    return {
        ...applicationSettings,
        settings: ApplicationSettingsSchema.parse(applicationSettings.settings)
    };
};
export const getOrganizationLocalizationTargets = async ({ applicationId })=>{
    return new Promise((resolve, reject)=>{
        db.application.findUnique({
            where: {
                id: applicationId
            },
            select: {
                organizationId: true
            }
        }).then((application)=>{
            const { organizationId } = application;
            db.organizationLocalizationTarget.findMany({
                where: {
                    organizationId
                },
                select: {
                    locale: true
                }
            }).then((localizations)=>resolve(localizations));
        });
    });
};
